import { InjectionToken } from '../../injection';
import { IMobizHttpService } from '../interfaces/mobiz-http.interface';

import { IAuthTokenService } from './auth-token.interface';
import { IMobizStateService } from './mobiz-state.interface';
import { IMobizStorageService } from './mobiz-storage.interface';

export interface IMobizContextService {
  /** The storage service. */
  storage: IMobizStorageService;
  /** The http service. */
  http: IMobizHttpService;
  /** The token service. */
  token: IAuthTokenService;
  /** The current state. */
  state: IMobizStateService;
}

export const IMobizContextService = new InjectionToken('IMobizContextService');
